export interface BookmarkEvent {
  id: string;
  name: {
    text: string;
    html: string;
  };
}

export interface BookmarksPagination {
  object_count: number;
  continuation: string | null;
  page_count: number;
  page_size: number;
  has_more_items: boolean;
  page_number: number;
}

export interface BookmarksResponse {
  pagination: BookmarksPagination;
  events: BookmarkEvent[];
}

export interface BookmarkStatus {
  isLiked: boolean;
  isAuthenticated: boolean;
}

export const DEFAULT_BOOKMARK_STATUS: BookmarkStatus = {
  isLiked: false,
  isAuthenticated: false,
};

export const LIKE_ACTION = 'save' as const;
export const UNLIKE_ACTION = 'unsave' as const;

export type BookmarkAction = typeof LIKE_ACTION | typeof UNLIKE_ACTION;
